import type { CropUnit } from '../state/historyStore';

export interface CropSizeMm {
  width: number;
  height: number;
}

export const TARGET_DPI = 300;
const MM_PER_CM = 10;
const MM_PER_INCH = 25.4;

export function convertToMm(value: number, unit: CropUnit): number {
  if (Number.isNaN(value)) {
    return 0;
  }
  switch (unit) {
    case 'cm':
      return value * MM_PER_CM;
    case 'in':
      return value * MM_PER_INCH;
    default:
      return value;
  }
}

export function convertFromMm(valueMm: number, unit: CropUnit): number {
  switch (unit) {
    case 'cm':
      return valueMm / MM_PER_CM;
    case 'in':
      return valueMm / MM_PER_INCH;
    default:
      return valueMm;
  }
}

export function formatDimension(valueMm: number, unit: CropUnit, fractionDigits = 1): string {
  const converted = convertFromMm(valueMm, unit);
  return formatNumber(converted, fractionDigits);
}

export function formatNumber(value: number, fractionDigits = 1): string {
  return Number.isFinite(value) ? value.toFixed(value >= 100 ? 0 : fractionDigits) : '0';
}

export function toPixels(mm: number, dpi = TARGET_DPI): number {
  return Math.max(1, Math.round((mm / MM_PER_INCH) * dpi));
}

export function clamp(value: number, min: number, max: number): number {
  if (Number.isNaN(value)) {
    return min;
  }
  return Math.min(Math.max(value, min), max);
}

export function normalizeSizeMm(size: CropSizeMm): CropSizeMm {
  return {
    width: Math.max(1, size.width),
    height: Math.max(1, size.height)
  };
}

export function getAspectRatio(size: CropSizeMm): number {
  const { width, height } = normalizeSizeMm(size);
  return width / height || 1;
}
